module.exports = __webpack_public_path__ + "img/tugboat_logo.9125c5af.svg";